import React, { useState, useEffect } from 'react';
import {  KoLoader} from 'packages';
import {  useParams } from 'react-router';
import MyView from './myView';
const ProjectMgmtDashboard = () => {
  // const [activeTab, setActiveTab] = useState();
  const [loading, setLoading] = useState(true);
  const { tabId } = useParams();
  // const navigate = useNavigate();
  useEffect(() => {
    // setActiveTab(tabId);
    setLoading(false);
  }, [tabId]);

  // let tabs = [
  //   {
  //     label: 'My Overview',
  //     key: 'myoverview',
  //     children: <MyView />
  //   },
  //   {
  //     label: 'Employee Productivity ',
  //     key: 'productivity',
  //     children: 'productivity'
  //   },
  //   {
  //     label: 'Reports',
  //     key: 'reports',
  //     children: 'reports'
  //   },
  //   {
  //     label: 'Utilisation',
  //     key: 'utilisation',
  //     children: 'Utilisation'
  //   },
  //   {
  //     label: 'Billing',
  //     key: 'billing',
  //     children: 'Billing'
  //   }, {
  //     label: 'Opportunity',
  //     key: 'opportunity',
  //     children: 'Opportunity'
  //   },
  //   {
  //     label: 'Project Health',
  //     key: 'projecthealth',
  //     children: 'Project Health'
  //   }

  // ];

  // const changeTabs = (key) => {
  //   navigate(`/home/${key}`);
  // };



  return (
    <div className={'profileSection'}>
      {loading && <KoLoader />}
      <MyView />
    </div>
  );
};
export default ProjectMgmtDashboard;